import { render, staticRenderFns } from "./AccountArchiveBtn.vue?vue&type=template&id=416355ea&"
import script from "./AccountArchiveBtn.vue?vue&type=script&lang=js&"
export * from "./AccountArchiveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports